export const toArray = <T>(target?: T | T[]): T[] => {
  return Array.isArray(target) ? target : target ? [target] : []
}
